import { Routes } from '@angular/router';

import { RoleBasedGuard, UserRole } from 'remarketing-angular-library';

import { UploadInServiceVehiclesShellComponent } from './components/upload-in-service-vehicles-shell/upload-in-service-vehicles-shell.component';
import { UploadInServiceVehiclesFileDetailsComponent } from './components/upload-in-service-vehicles-file-details/upload-in-service-vehicles-file-details.component';

export const inServiceVehicleRoutes: Routes = [
  {
    path: 'upload-vehicles',
    component: UploadInServiceVehiclesShellComponent,
    canActivate: [RoleBasedGuard],
    data: { roles: [UserRole.VEHICLE_UPLOAD] }
  },
  {
    path: 'upload-vehicles/:fileUuid',
    component: UploadInServiceVehiclesFileDetailsComponent,
    canActivate: [RoleBasedGuard],
    data: { roles: [UserRole.VEHICLE_UPLOAD] }
  }
];
